export default {
    nav: {
        home: "Trang chủ",
        products: "Sản phẩm",
        contact: "Liên hệ",
        myAccount: "Tài khoản của tôi",
        logout: "Đăng xuất",
        loginRegister: "Đăng nhập / Đăng ký",
        login: "Đăng nhập",
        register: "Đăng ký",
        account: "Tài khoản",
        signOut: "Đăng xuất",
        openMenu: "Mở menu"
    },
    footer: {
        tagline: "Tinh hoa mây tre đan Việt Nam, mang hơi thở thiên nhiên vào không gian sống hiện đại.",
        buyOnline: "Mua Online",
        catalogue: "Tải Catalogue",
        generalInfo: "Thông tin chung",
        contact: "Liên hệ",
        shippingPolicy: "Chính sách vận chuyển",
        warrantyPolicy: "Chính sách bảo hành",
        faq: "Câu hỏi thường gặp",
        aboutUs: "Về Chúng Tôi",
        aboutText:
            "Rattanovi - Thương hiệu/nhà sản xuất đồ tre mỹ nghệ hàng đầu với 15 năm kinh nghiệm. Chúng tôi tự hào mang đến những sản phẩm thân thiện môi trường, kết hợp tinh hoa nghệ thuật và thiên nhiên.",
        phone: "0325738794 (FB/Zalo)",
        handmadeWithCare: "Handmade with care · Rattanovi"
    },
    home: {
        craftTag: "Mây tre thủ công",
        heroDesc:
            "Sản phẩm thủ công từ vật liệu tự nhiên, được chọn lọc cho những không gian sống ấm áp, bền vững và có câu chuyện.",
        viewProducts: "Xem sản phẩm",
        ourStory: "Câu chuyện",
        newProductsTag: "Sản phẩm mới",
        curatedTitle: "Chọn lọc cho ngôi nhà",
        viewAll: "Xem tất cả",
        fromVillageTag: "Từ làng nghề",
        keepDetailTitle: "Giữ chất mộc trong từng chi tiết",
        storyText:
            "Mỗi sản phẩm được tạo nên từ kỹ thuật đan lát, xử lý vật liệu và hoàn thiện thủ công. Thiết kế ưu tiên công năng, độ bền và vẻ đẹp tự nhiên của mây tre Việt.",
        artisans: "nghệ nhân",
        villages: "làng nghề",
        natural: "tự nhiên",
        collectionsTag: "Bộ sưu tập",
        easyStyleTitle: "Dễ phối trong từng góc nhà",
        quote: "“Một sản phẩm tốt không chỉ đẹp trên kệ, mà còn làm nhịp sống hằng ngày chậm lại và dễ chịu hơn.”",
        collectionLivingTitle: "Không gian sống",
        collectionLivingText: "Các món trang trí nhẹ nhàng cho phòng khách, bàn trà và góc đọc sách.",
        collectionKitchenTitle: "Bếp và bàn ăn",
        collectionKitchenText: "Khay, rổ, hộp đựng và vật dụng thủ công cho nhịp sống hàng ngày.",
        collectionGiftTitle: "Quà tặng thủ công",
        collectionGiftText: "Những sản phẩm có chất liệu tự nhiên, phù hợp làm quà tặng tinh tế.",
        heroImageAlt: "Không gian thủ công Việt",
        storyImageAlt: "Nghề thủ công truyền thống"
    },
    menu: {
        title: "Bộ sưu tập Mây Tre",
        subtitle:
            "Khám phá vẻ đẹp mộc mạc và tinh tế của các sản phẩm thủ công truyền thống, mang hơi thở thiên nhiên vào không gian sống hiện đại.",
        categoryHeading: "Danh mục",
        allProducts: "Tất cả sản phẩm",
        materialHeading: "Chất liệu",
        sortHeading: "Sắp xếp",
        searchPlaceholder: "Tìm sản phẩm...",
        searchButton: "Tìm kiếm",
        sortNewest: "Mới nhất",
        sortPriceAsc: "Giá tăng dần",
        searchByName: "Tên sản phẩm",
        searchByBrand: "Thương hiệu",
        searchByCountry: "Xuất xứ",
        materialNatural: "Mây tự nhiên",
        materialSmokedBamboo: "Tre hun khói",
        materialReed: "Nứa đan",
        materialMixed: "Kết hợp"
    },
    productCard: {
        size: "Kích thước",
        reviews: "{{count}} đánh giá",
        noReviews: "Chưa có đánh giá",
        addToCart: "Thêm vào giỏ",
        edit: "Sửa",
        delete: "Xóa"
    },
    product: {
        imageAlt: "Ảnh {{index}}",
        reviewsCount: "{{count}} đánh giá",
        inStock: "Còn hàng",
        outOfStock: "Hết hàng",
        addToCart: "Thêm vào giỏ",
        type: "Loại sản phẩm",
        size: "Kích thước",
        length: "Dài",
        width: "Rộng",
        height: "Cao",
        diameter: "Đường kính",
        origin: "Xuất xứ",
        year: "Năm sản xuất",
        material: "Chất liệu / bảo quản",
        description: "Mô tả",
        reviewsTitle: "Đánh giá",
        noReviews: "Sản phẩm này chưa có đánh giá nào.",
        yourName: "Tên của bạn",
        yourMark: "Chấm điểm",
        messageText: "Nội dung",
        postReview: "Gửi đánh giá"
    },
    cart: {
        title: "Giỏ hàng",
        empty: "Giỏ hàng của bạn đang trống",
        emptyDesc: "Hãy khám phá bộ sưu tập mây tre và thêm những sản phẩm bạn yêu thích.",
        continueShopping: "Tiếp tục mua sắm",
        orderSummary: "Tóm tắt đơn hàng",
        subtotal: "Tạm tính ({{count}} sản phẩm)",
        shippingFee: "Phí vận chuyển",
        shippingCalcAtCheckout: "Tính khi thanh toán",
        total: "Tổng cộng",
        checkout: "Thanh toán",
        decreaseAria: "Giảm số lượng",
        increaseAria: "Tăng số lượng",
        remove: "Xóa"
    },
    order: {
        title: "Đặt hàng",
        firstName: "Họ:",
        lastName: "Tên:",
        city: "Thành phố:",
        address: "Địa chỉ:",
        postIndex: "Mã bưu điện:",
        phone: "Số điện thoại:",
        email: "Email:",
        firstNamePlaceholder: "Nhập họ",
        lastNamePlaceholder: "Nhập tên",
        cityPlaceholder: "Nhập thành phố",
        addressPlaceholder: "Nhập địa chỉ",
        postIndexPlaceholder: "Nhập mã bưu điện",
        phonePlaceholder: "0912 345 678",
        emailPlaceholder: "example@gmail.com",
        payment: "Thanh toán:",
        placeOrder: "Đặt hàng",
        itemPrice: "Giá:",
        itemQuantity: "Số lượng:"
    },
    orderFinalize: {
        thankYou: "Cảm ơn bạn đã đặt hàng!",
        orderNumber: "Mã đơn hàng của bạn là: {{id}}"
    },
    login: {
        heroTitle: "Gìn giữ nét đẹp truyền thống trong không gian hiện đại.",
        heroDesc:
            "Hành trình mang tinh hoa mây tre đan Việt Nam đến với mọi ngôi nhà, nơi mỗi sản phẩm là một câu chuyện về sự tỉ mỉ và tâm huyết.",
        heroBadge: "+2,000 nghệ nhân và khách hàng đồng hành",
        welcomeBack: "Chào mừng trở lại",
        subtitle: "Vui lòng đăng nhập để tiếp tục khám phá các tác phẩm thủ công.",
        email: "Email",
        password: "Mật khẩu",
        forgotPassword: "Quên mật khẩu?",
        remember: "Ghi nhớ đăng nhập",
        submit: "Đăng nhập",
        noAccount: "Chưa có tài khoản?",
        registerNow: "Đăng ký ngay",
        orContinueWith: "Hoặc tiếp tục với",
        togglePassword: "Hiện/ẩn mật khẩu"
    },
    registration: {
        heroTitle: "Bắt đầu hành trình cùng nghề thủ công Việt.",
        heroDesc: "Tạo tài khoản để nhận ưu đãi, theo dõi đơn hàng và lưu lại những món đồ mây tre yêu thích.",
        heroBadge: "+2,000 nghệ nhân và khách hàng đồng hành",
        title: "Bắt đầu hành trình",
        subtitle: "Tạo tài khoản để nhận ưu đãi và lưu lại những món đồ yêu thích.",
        successMessage: "Đăng ký thành công! Vui lòng kiểm tra email để kích hoạt tài khoản.",
        firstName: "Họ",
        firstNamePlaceholder: "Nguyễn",
        lastName: "Tên",
        lastNamePlaceholder: "Văn A",
        email: "Email",
        password: "Mật khẩu",
        passwordPlaceholder: "Tối thiểu 6 ký tự",
        confirmPassword: "Xác nhận mật khẩu",
        confirmPasswordPlaceholder: "Nhập lại mật khẩu",
        submit: "Đăng ký tài khoản",
        haveAccount: "Đã có tài khoản?",
        loginNow: "Đăng nhập"
    },
    forgotPassword: {
        title: "Quên mật khẩu?",
        instructions: "Nhập địa chỉ email bạn đã dùng để tạo tài khoản.",
        email: "Email:",
        emailPlaceholder: "Email",
        emailRequired: "Vui lòng nhập email!",
        send: "Gửi"
    },
    resetPassword: {
        title: "Đặt lại mật khẩu",
        password: "Mật khẩu:",
        passwordPlaceholder: "Mật khẩu",
        confirmPassword: "Xác nhận mật khẩu:",
        confirmPasswordPlaceholder: "Xác nhận mật khẩu",
        reset: "Đặt lại"
    },
    contacts: {
        title: "Liên hệ",
        phone: "Điện thoại: ",
        phoneValue: "0325 738 794 (FB/Zalo)",
        email: "Email: ",
        workingHours: "Giờ làm việc",
        workingHoursText: "Cửa hàng mở cửa từ 08:00 đến 20:00, tất cả các ngày trong tuần.",
        onlineOrders: "Đơn hàng online được tiếp nhận 24/7.",
        delivery: "Giao hàng",
        deliveryText: "Đơn hàng được giao qua dịch vụ vận chuyển.",
        connectWithUs: "Kết nối với chúng tôi"
    },
    chat: {
        supportTitle: "Hỗ trợ Rattanovi",
        responseTime: "Thường trả lời trong ít phút",
        close: "Đóng",
        greeting: "Chào bạn 👋 Cần tư vấn sản phẩm mây tre? Nhắn cho shop nhé!",
        inputPlaceholder: "Nhập tin nhắn...",
        send: "Gửi",
        openAria: "Chat với shop"
    },
    account: {
        fallbackName: "Tài khoản",
        roleCustomer: "Khách hàng",
        personalInfo: "Thông tin cá nhân",
        personalInfoDesc: "Cập nhật thông tin giao hàng",
        changePassword: "Đổi mật khẩu",
        myOrders: "Đơn hàng của tôi",
        myOrdersDesc: "Theo dõi các đơn đã đặt",
        greeting: "Xin chào, {{name}}!",
        customerSubtitle: "Chào mừng bạn quay lại. Quản lý đơn hàng và thông tin cá nhân của bạn tại đây.",
        noOrders: "Bạn chưa có đơn hàng nào",
        orderId: "Mã đơn",
        orderDate: "Ngày đặt",
        customerName: "Khách hàng",
        email: "Email",
        totalAmount: "Tổng tiền",
        actions: "Thao tác",
        viewDetails: "Xem chi tiết",
        orderNumberTitle: "Đơn hàng #{{id}}",
        customerInfo: "Thông tin khách hàng",
        orderInfo: "Thông tin đơn hàng",
        fullName: "Họ và tên",
        orderTotal: "Tổng đơn hàng",
        productCode: "Mã SP",
        vendor: "Thương hiệu",
        productName: "Tên sản phẩm",
        quantity: "Số lượng",
        unitPrice: "Đơn giá",
        lineTotal: "Thành tiền"
    },
    changePassword: {
        title: "Đổi mật khẩu",
        newPassword: "Mật khẩu mới",
        confirmPassword: "Xác nhận mật khẩu",
        passwordPlaceholder: "Mật khẩu",
        submit: "Đổi mật khẩu"
    },
    personalData: {
        title: "Thông tin cá nhân",
        email: "Email",
        firstName: "Họ",
        lastName: "Tên",
        city: "Thành phố",
        address: "Địa chỉ",
        phone: "Số điện thoại",
        postIndex: "Mã bưu chính",
        edit: "Chỉnh sửa",
        hide: "Ẩn",
        firstNameLabel: "Họ:",
        lastNameLabel: "Tên:",
        cityLabel: "Thành phố:",
        addressLabel: "Địa chỉ:",
        phoneLabel: "Số điện thoại:",
        postIndexLabel: "Mã bưu chính:",
        firstNamePlaceholder: "Nhập họ",
        lastNamePlaceholder: "Nhập tên",
        cityPlaceholder: "Nhập thành phố",
        addressPlaceholder: "Nhập địa chỉ",
        phonePlaceholder: "Nhập số điện thoại",
        postIndexPlaceholder: "Nhập mã bưu chính",
        save: "Lưu"
    }
};
